import { FC } from 'react';

type GradientStop = {
  offset: string;
  stopColor: string;
  stopOpacity: number;
};

type BaseGradientProps = {
  id: string;
  stops: GradientStop[];
};

type RadialGradientProps = BaseGradientProps & {
  cx: string;
  cy: string;
  r: string;
  gradientUnits?: string;
};

type LinearGradientProps = BaseGradientProps & {
  x1: string;
  y1: string;
  x2: string;
  y2: string;
};

export const RadialGradient: FC<RadialGradientProps> = ({ id, cx, cy, r, stops, gradientUnits }) => (
  <radialGradient id={id} cx={cx} cy={cy} r={r} gradientUnits={gradientUnits}>
    {stops.map((stop, index) => (
      <stop key={index} offset={stop.offset} stopColor={stop.stopColor} stopOpacity={stop.stopOpacity} />
    ))}
  </radialGradient>
);

export const LinearGradient: FC<LinearGradientProps> = ({ id, x1, y1, x2, y2, stops }) => (
  <linearGradient id={id} x1={x1} y1={y1} x2={x2} y2={y2}>
    {stops.map((stop, index) => (
      <stop key={index} offset={stop.offset} stopColor={stop.stopColor} stopOpacity={stop.stopOpacity} />
    ))}
  </linearGradient>
);
